module.exports = __webpack_public_path__ + "img/cooperation15.3c50c81e.png";